module.exports = __webpack_public_path__ + "static/media/vectorsmartobject-4.7492ffa6.png";